import {
    Modal,
    Form,
    Select,
    Button
} from 'antd';

const AddRunHaresModal = (props) => {
    const [formAddHare] = Form.useForm();
    const {
        visible,
        onCancel,
        onSubmit,
        membersData,
    } = props;

    const handleSubmit = () => {
        if (!formAddHare) return;
        formAddHare.submit();
    };

    const handleFinish = (values) => {
        if (onSubmit) {
            onSubmit(values);
            formAddHare.resetFields();
        }
    };

    const modalFooter = { onCancel };

    const getModalContent = () => {
        return (
            <Form
                form={formAddHare}
                name="formAddHare"
                onFinish={handleFinish}
            >
                <Form.Item
                    name="member_id"
                    rules={[{ required: true, message: 'Please select a hare' }]}
                    labelCol={{ span: 24 }}
                >
                    <Select
                        showSearch
                        mode="multiple"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase())
                        }
                        filterSort={(optionA, optionB) =>
                            (optionA?.label?.toLowerCase() ?? '').localeCompare((optionB?.label?.toLowerCase() ?? ''))
                        }
                        options={membersData}
                    />
                </Form.Item>
            </Form>
        );
    };

    return (
        <Modal
            title='Add Hare'
            destroyOnClose
            open={visible}
            {...modalFooter}
            footer={[
                <Button key="submit" type="primary" onClick={handleSubmit}>
                    Add
                </Button>
            ]}
        >
            {getModalContent()}
        </Modal>
    );
};

export default AddRunHaresModal;
